import { DESKTOP_NATIVE_ENGLISH } from "./desktop-native"

export const dict = {
  ...DESKTOP_NATIVE_ENGLISH,
  "ssh.label": "SSH",
  "ssh.offline": "Not connected to {{host}}. Your draft is preserved; remote work may still be running.",
  "ssh.placeholder": "ssh user@example.com",
  "ssh.add": "Add SSH server",
  "ssh.server.menu.label": "SSH server",
  "ssh.target": "Host or SSH command",
  "ssh.connect": "Connect",
  "ssh.connectTo": "Connect to {{host}}",
  "ssh.authenticate": "SSH authentication",
  "ssh.action.authenticate": "Authenticate",
  "ssh.session.disconnected": "SSH connection inactive",
  "ssh.session.connecting": "Connecting to SSH server",
  "ssh.session.reconnectDescription":
    "Reconnect to view this session and continue working. Your remote session is preserved.",
  "ssh.session.reconnect": "Reconnect",
  "ssh.authenticationRequired": "Authentication required for {{host}}",
  "ssh.trust": "Trust and connect",
  "ssh.continue": "Continue",
  "ssh.retry": "Retry",
  "ssh.update": "Update and reconnect",
  "ssh.openProject": "Open project",
  "ssh.project": "Open project on {{host}}",
  "ssh.disconnect": "Disconnect",
  "ssh.forget": "Forget connection",
  "ssh.stage.disconnected": "Disconnected. The remote server is left running.",
  "ssh.stage.connecting": "Connecting over SSH…",
  "ssh.stage.checking": "Checking OpenTAG…",
  "ssh.stage.downloading": "Downloading server…",
  "ssh.stage.uploading": "Uploading server…",
  "ssh.stage.starting": "Connecting to OpenTAG…",
  "ssh.stage.ready": "Connected",
  "ssh.stage.authentication": "Authentication required",
  "ssh.stage.incompatible": "Server update required",
  "ssh.stage.failed": "Connection failed",
  "ssh.error.input":
    "Enter a host or SSH connection command. Remote commands and unsupported SSH options aren’t allowed.",
  "ssh.error.connection": "Could not establish the SSH connection. Check your network and SSH configuration.",
  "ssh.error.platform":
    "This remote platform is not supported. Automatic setup currently requires Linux or macOS on x64 or arm64.",
  "ssh.error.version": "The remote service must match this Desktop version before connecting.",
  "ssh.error.install":
    "Could not install the remote server. Check connectivity, disk space, and that tar is installed.",
  "ssh.error.unpublished":
    "This Desktop version has no published remote server. For development builds, install and start V2 on the host, then retry.",
  "ssh.error.service": "SSH connected, but the OpenTAG server did not become ready.",
  "ssh.error.host-key":
    "The host’s identity could not be verified. Verify its fingerprint before updating your SSH known hosts.",
  "ssh.error.ssh-missing": "OpenSSH was not found. Install an OpenSSH client and ensure ssh is available on PATH.",
  "session.location.unavailable": "Session location unavailable",
  "session.location.description": "Choose another directory to continue this session.",
  "session.location.choose": "Choose directory",
  "session.location.worktree": "Choose worktree",
  "session.location.worktreesFailed": "Failed to load worktrees",
  "session.location.moving": "Moving session…",
  "command.category.suggested": "Suggested",
  "command.category.view": "View",
  "command.category.project": "Project",
  "command.category.provider": "Provider",
  "command.category.server": "Server",
  "command.category.session": "Session",
  "command.category.theme": "Theme",
  "command.category.language": "Language",
  "command.category.file": "File",
  "command.category.context": "Context",
  "command.category.terminal": "Terminal",
  "command.category.model": "Model",
  "command.category.mcp": "MCP",
  "command.category.agent": "Agent",
  "command.category.permissions": "Permissions",
  "command.category.workspace": "Worktree",
  "command.category.settings": "Settings",
  "command.logs.export": "Export logs",
  "command.debugBar.toggle": "Toggle debug bar",

  "theme.scheme.system": "System",
  "theme.scheme.light": "Light",
  "theme.scheme.dark": "Dark",

  "command.sidebar.toggle": "Toggle sidebar",
  "command.project.open": "Open project",
  "command.project.previous": "Previous project",
  "command.project.next": "Next project",
  "command.project.index": "Switch to project {{index}}",
  "command.project.copyID": "Copy Project ID",
  "command.provider.connect": "Connect provider",
  "command.provider.connect.description": "Sign in to OpenCode Go, OpenCode Console, or another model provider",
  "command.server.switch": "Switch server",
  "command.settings.open": "Open settings",
  "command.session.previous": "Previous session",
  "command.session.next": "Next session",
  "command.session.previous.unseen": "Previous unread session",
  "command.session.next.unseen": "Next unread session",
  "command.session.archive": "Archive session",
  "command.session.location.cycle": "Cycle session location",

  "command.palette": "Command palette",

  "command.theme.cycle": "Cycle theme",
  "command.theme.set": "Use theme: {{theme}}",
  "command.theme.scheme.cycle": "Cycle color scheme",
  "command.theme.scheme.set": "Use color scheme: {{scheme}}",

  "command.language.cycle": "Cycle language",
  "command.language.set": "Use language: {{language}}",

  "command.session.new": "New session",
  "command.file.open": "Open file",
  "command.browser.open": "Open browser",
  "command.browser.reload": "Reload browser page",
  "command.tab.close": "Close tab",
  "command.tab.reopenClosed": "Reopen closed tab",
  "command.context.addSelection": "Add selection to context",
  "command.context.addSelection.description": "Add selected lines from the current file",
  "command.input.focus": "Focus input",
  "command.terminal.toggle": "Toggle terminal",
  "command.fileTree.toggle": "Toggle file tree",
  "command.review.toggle": "Toggle review",
  "command.session.summary.toggle": "Toggle summary",
  "command.terminal.new": "New terminal",
  "command.terminal.new.description": "Create a new terminal tab",
  "command.steps.toggle": "Toggle steps",
  "command.steps.toggle.description": "Show or hide steps for the current message",
  "command.message.previous": "Previous message",
  "command.message.previous.description": "Go to the previous user message",
  "command.message.next": "Next message",
  "command.message.next.description": "Go to the next user message",
  "command.model.choose": "Choose model",
  "command.model.choose.description": "Select a different model",
  "command.mcp.toggle": "Toggle MCPs",
  "command.mcp.toggle.description": "Toggle MCPs",
  "command.agent.cycle": "Cycle agent",
  "command.agent.cycle.description": "Switch to the next agent",
  "command.agent.cycle.reverse": "Cycle agent backwards",
  "command.agent.cycle.reverse.description": "Switch to the previous agent",
  "command.model.variant.cycle": "Cycle thinking effort",
  "command.model.variant.cycle.description": "Switch to the next effort level",
  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",
  "command.permissions.autoaccept.enable": "Auto-accept permissions",
  "command.permissions.autoaccept.disable": "Stop auto-accepting permissions",
  "command.workspace.toggle": "Toggle worktrees",
  "command.workspace.toggle.description": "Enable or disable multiple worktrees in the sidebar",
  "command.session.undo": "Undo",
  "command.session.undo.description": "Undo the last message",
  "command.session.redo": "Redo",
  "command.session.redo.description": "Redo the last undone message",
  "command.session.compact": "Compact session",
  "command.session.compact.description": "Summarize the session to reduce context size",
  "command.session.fork": "Fork from message",
  "command.session.fork.description": "Create a new session from a previous message",
  "command.session.btw": "Ask a side question",
  "command.session.btw.description": "Get a one-shot answer without adding to the conversation",
  "command.session.export": "Export session",
  "command.session.export.description": "Export the full session transcript as JSON",
  "command.session.import": "Import session",
  "command.session.copyID": "Copy Session ID",

  "palette.search.placeholder": "Search files, commands, and sessions",
  "palette.search.placeholder.home": "Search commands and sessions",
  "palette.empty": "No results found",
  "palette.group.commands": "Commands",
  "palette.group.files": "Files",

  "dialog.provider.search.placeholder": "Search providers",
  "dialog.provider.empty": "No providers found",
  "dialog.provider.group.popular": "Popular",
  "dialog.provider.group.other": "Other",
  "dialog.provider.custom.label": "Custom OpenAI-compatible provider",
  "dialog.provider.tag.recommended": "Recommended",
  "dialog.provider.opencode.note": "Curated models including Claude, GPT, Gemini and more",
  "dialog.provider.opencode.tagline": "Reliable optimized models",
  "dialog.provider.opencodeGo.tagline": "Low cost subscription for everyone",
  "dialog.provider.anthropic.note": "Direct access to Claude models via API key",
  "dialog.provider.copilot.note": "AI models for coding assistance via GitHub Copilot",
  "dialog.provider.openai.note": "GPT models for fast, capable general AI tasks",
  "dialog.provider.google.note": "Gemini models for fast, structured responses",
  "dialog.provider.openrouter.note": "Access all supported models from one provider",
  "dialog.provider.vercel.note": "Unified access to AI models with smart routing",

  "dialog.model.select.title": "Select model",
  "dialog.model.search.placeholder": "Search models",
  "dialog.model.empty": "No model results",
  "dialog.model.manage": "Manage models",
  "dialog.model.manage.description": "Customize which models appear in the model selector.",
  "dialog.model.chatgptPlan": "Using ChatGPT plan",
  "dialog.model.chatgptManageUsage": "Manage usage",
  "dialog.model.manage.provider.toggle": "Toggle all {{provider}} models",

  "dialog.model.unpaid.freeModels.title": "Free models provided by OpenTAG",
  "dialog.model.unpaid.addMore.title": "Add more models from popular providers",
  "dialog.model.unpaid.viewMoreProviders": "See 70+ more providers",

  "dialog.provider.viewAll": "Show more providers",

  "provider.connect.title": "Connect {{provider}}",
  "provider.connect.opencode.name": "OpenCode Console",
  "provider.connect.opencode.freeName": "OpenCode Free",
  "provider.connect.console.title": "Connecting to OpenCode Console",
  "provider.connect.console.instructions":
    "Continue in your browser. Confirm the code shown there matches the one below.",
  "provider.connect.console.deviceCode": "Device code",
  "provider.connect.console.deviceCode.label": "Device code: {{code}}",
  "provider.connect.console.waiting": "Waiting for confirmation…",
  "provider.connect.console.browserHint": "Browser didn't open?",
  "provider.connect.console.copyLink": "Copy sign-in link",
  "provider.connect.console.linkCopied": "Sign-in link copied",
  "provider.connect.console.copyFailed": "Couldn't copy the sign-in link. Open Console again to continue.",
  "provider.connect.console.openAgain": "Open Console again",
  "provider.connect.console.browserFailed":
    "We couldn't open your browser. Try again or copy the sign-in link to continue.",
  "provider.connect.console.expired": "This sign-in request has expired. Start again to get a new device code.",
  "provider.connect.console.denied": "Access was denied in Console. Try again when you're ready to connect.",
  "provider.connect.console.statusFailed": "Couldn't check authorization. Check your server connection and try again.",
  "provider.connect.console.startFailed": "Couldn't start sign-in. Check your server connection and try again.",
  "provider.connect.models.title": "Connected to {{provider}}",
  "provider.connect.models.description": "Choose a model to start with. You can switch models anytime.",
  "provider.connect.models.available": "Available models",
  "provider.connect.chatgptWelcome.title": "You're using your ChatGPT plan",
  "provider.connect.chatgptWelcome.description": "Eligible requests in OpenTAG use your ChatGPT plan.",
  "provider.connect.chatgptWelcome.usage": "Manage usage in ChatGPT settings",
  "provider.connect.chatgptWelcome.confirm": "Got it",
  "provider.connect.models.list": "Models available from {{provider}}",
  "provider.connect.chatgptUsageLimit.title": "ChatGPT usage limit reached",
  "provider.connect.chatgptUsageLimit.description": "Review your usage settings in ChatGPT.",
  "provider.connect.chatgptUsageLimit.manage": "Manage usage",
  "provider.connect.chatgptUsageLimit.close": "Close",
  "provider.connect.console.refreshFailed":
    "Your account is connected, but we couldn't load your models. Try again to refresh them.",
  "provider.connect.console.connected": "OpenTAG connected",
  "provider.connect.console.noModels":
    "Your account is connected, but this Console workspace has no available models. Check its setup in Console, then refresh.",
  "provider.connect.console.modelsLoading": "Your models are still loading. Refresh to check again.",
  "provider.connect.console.refresh": "Refresh models",
  "provider.connect.console.openingBrowser": "Opening browser…",
  "provider.connect.console.serviceAccount": "Service account?",
  "provider.connect.console.useApiKey": "Use API key",
  "provider.connect.remote.title": "Connecting on “{{server}}”",
  "provider.connect.remote.description":
    "Your OpenTAG credentials will be stored on this server. Models will be available through this server.",
  "provider.connect.form.unsupported": "This authentication form contains unsupported fields",
  "provider.connect.title.anthropicProMax": "Login with Anthropic",
  "provider.connect.selectMethod": "Select login method for {{provider}}.",
  "provider.connect.method.apiKey": "API key",
  "provider.connect.method.browser": "Browser",
  "provider.connect.method.headless": "Headless",
  "provider.connect.status.inProgress": "Authorization in progress…",
  "provider.connect.status.waiting": "Waiting for authorization…",
  "provider.connect.status.failed": "Authorization failed: {{error}}",
  "provider.connect.error.unsupportedFields": "This authentication form contains unsupported fields",
  "provider.connect.apiKey.description":
    "Enter your {{provider}} API key to connect your account and use {{provider}} models in OpenTAG.",
  "provider.connect.apiKey.label": "{{provider}} API key",
  "provider.connect.apiKey.placeholder": "API key",
  "provider.connect.apiKey.required": "API key is required",
  "provider.connect.opencodeZen.line1":
    "OpenCode Zen gives you access to a curated set of reliable optimized models for coding agents.",
  "provider.connect.opencodeZen.line2":
    "With a single API key you'll get access to models such as Claude, GPT, Gemini, GLM and more.",
  "provider.connect.opencodeZen.visit.prefix": "Visit ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " to collect your API key.",
  "provider.connect.oauth.code.visit.prefix": "Visit ",
  "provider.connect.oauth.code.visit.link": "this link",
  "provider.connect.oauth.code.visit.suffix":
    " to collect your authorization code to connect your account and use {{provider}} models in OpenTAG.",
  "provider.connect.oauth.code.label": "{{method}} authorization code",
  "provider.connect.oauth.code.placeholder": "Authorization code",
  "provider.connect.oauth.code.required": "Authorization code is required",
  "provider.connect.oauth.code.invalid": "Invalid authorization code",
  "provider.connect.oauth.auto.visit.prefix": "Visit ",
  "provider.connect.oauth.auto.visit.link": "this link",
  "provider.connect.oauth.auto.visit.suffix":
    " and enter the code below to connect your account and use {{provider}} models in OpenTAG.",
  "provider.connect.oauth.auto.confirmationCode": "Confirmation code",
  "provider.connect.oauth.auto.confirmationCode.description":
    "Check that your browser shows the same code before you authorize.",
  "provider.connect.oauth.auto.description":
    "Your browser opens so you can sign in to {{provider}}. Come back here when you are done.",
  "provider.connect.oauth.code.description":
    "Your browser opens so you can sign in to {{provider}}. Paste the authorization code it gives you below.",
  "provider.connect.oauth.openBrowser": "Open browser",
  "provider.connect.oauth.expired": "Authorization expired",
  "provider.connect.console.apiKey.description":
    "Paste an API key for a service account. You create service accounts in the OpenCode Console under Keys.",
  "provider.connect.console.apiKey.link": "Open the Console",
  "provider.connect.toast.connected.title": "{{provider}} connected",
  "provider.connect.toast.connected.description": "{{provider}} models are now available to use.",

  "provider.custom.title": "Custom provider",
  "provider.custom.unavailable": "Custom providers are unavailable on this server",
  "provider.custom.description.prefix": "Configure an OpenAI-compatible provider. See the ",
  "provider.custom.description.link": "provider config docs",
  "provider.custom.description.suffix": ".",
  "provider.custom.field.providerID.label": "Provider ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "Lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.field.name.label": "Display name",
  "provider.custom.field.name.placeholder": "My AI Provider",
  "provider.custom.field.baseURL.label": "Base URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API key",
  "provider.custom.field.apiKey.placeholder": "API key",
  "provider.custom.field.apiKey.description": "Optional. Leave empty if you manage auth via headers.",
  "provider.custom.models.label": "Models",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "Name",
  "provider.custom.models.name.placeholder": "Display Name",
  "provider.custom.models.remove": "Remove model",
  "provider.custom.models.add": "Add model",
  "provider.custom.headers.label": "Headers (optional)",
  "provider.custom.headers.key.label": "Header",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "Value",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "Remove header",
  "provider.custom.headers.add": "Add header",
  "provider.custom.error.providerID.required": "Provider ID is required",
  "provider.custom.error.providerID.format": "Use lowercase letters, numbers, hyphens, or underscores",
  "provider.custom.error.providerID.exists": "That provider ID already exists",
  "provider.custom.error.name.required": "Display name is required",
  "provider.custom.error.baseURL.required": "Base URL is required",
  "provider.custom.error.baseURL.format": "Must start with http:// or https://",
  "provider.custom.error.required": "Required",
  "provider.custom.error.duplicate": "Duplicate",

  "provider.disconnect.toast.disconnected.title": "{{provider}} disconnected",
  "provider.disconnect.toast.disconnected.description": "{{provider}} models are no longer available.",
  "provider.disconnect.toast.noCredentials.description": "No removable credentials found for {{provider}}",
  "provider.disconnect.toast.failed.description": "Failed to disconnect {{provider}}.",

  "model.tag.free": "Free",
  "model.tag.latest": "Latest",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "text",
  "model.input.image": "image",
  "model.input.audio": "audio",
  "model.input.video": "video",
  "model.input.pdf": "pdf",
  "model.tooltip.allows": "Allows: {{inputs}}",
  "model.tooltip.context.label": "Context",
  "model.tooltip.inputs": "Inputs",
  "model.tooltip.model": "Model",
  "model.tooltip.provider": "Provider",
  "model.tooltip.reasoning": "Reasoning",
  "model.tooltip.reasoning.allowed": "Allows reasoning",
  "model.tooltip.reasoning.none": "No reasoning",
  "model.tooltip.context": "Context limit {{limit}}",

  "common.search.placeholder": "Search",
  "common.goBack": "Navigate back",
  "common.goForward": "Navigate forward",
  "common.loading": "Loading",
  "common.loading.ellipsis": "…",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.color.orange": "orange",
  "common.color.yellow": "yellow",
  "common.color.cyan": "cyan",
  "common.color.green": "green",
  "common.color.red": "red",
  "common.color.pink": "pink",
  "common.color.blue": "blue",
  "common.color.purple": "purple",
  "common.color.gray": "gray",
  "common.open": "Open",
  "common.connect": "Connect",
  "common.disconnect": "Disconnect",
  "common.continue": "Continue",
  "common.retry": "Try again",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.default": "Default",
  "common.attachment": "attachment",

  "prompt.placeholder.shell": "Enter shell command… {{example}}",
  "prompt.placeholder.normal": 'Ask anything… "{{example}}"',
  "prompt.placeholder.simple": "Ask anything…",
  "prompt.placeholder.summarizeComments": "Summarize comments…",
  "prompt.placeholder.summarizeComment": "Summarize comment…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "esc to exit",
  "session.child.promptDisabled": "Subagent sessions cannot be prompted.",
  "session.child.backToParent": "Back to main session.",

  "prompt.example.1": "Fix a TODO in the codebase",
  "prompt.example.2": "What is the tech stack of this project?",
  "prompt.example.3": "Fix broken tests",
  "prompt.example.4": "Explain how authentication works",
  "prompt.example.5": "Find and fix security vulnerabilities",
  "prompt.example.6": "Add unit tests for the user service",
  "prompt.example.7": "Refactor this function to be more readable",
  "prompt.example.8": "What does this error mean?",
  "prompt.example.9": "Help me debug this issue",
  "prompt.example.10": "Generate API documentation",
  "prompt.example.11": "Optimize database queries",
  "prompt.example.12": "Add input validation",
  "prompt.example.13": "Create a new component for…",
  "prompt.example.14": "How do I deploy this project?",
  "prompt.example.15": "Review my code for best practices",
  "prompt.example.16": "Add error handling to this function",
  "prompt.example.17": "Explain this regex pattern",
  "prompt.example.18": "Convert this to TypeScript",
  "prompt.example.19": "Add logging throughout the codebase",
  "prompt.example.20": "What dependencies are outdated?",
  "prompt.example.21": "Help me write a migration script",
  "prompt.example.22": "Implement caching for this endpoint",
  "prompt.example.23": "Add pagination to this list",
  "prompt.example.24": "Create a CLI command for…",
  "prompt.example.25": "How do environment variables work here?",

  "prompt.popover.emptyResults": "No matching results",
  "prompt.popover.emptyCommands": "No matching commands",
  "prompt.dropzone.label": "Drop images, PDFs, or text files here",
  "prompt.dropzone.file.label": "Drop to @mention file",
  "prompt.slash.badge.custom": "custom",
  "prompt.slash.badge.skill": "skill",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "active",
  "prompt.context.includeActiveFile": "Include active file",
  "prompt.context.removeActiveFile": "Remove active file from context",
  "prompt.context.removeFile": "Remove file from context",
  "prompt.action.attachFile": "Add files",
  "prompt.menu.addImagesAndFiles": "Add files and more",
  "prompt.menu.imagesAndFiles": "Images and files",
  "prompt.menu.commands": "Commands",
  "prompt.menu.context": "Context",
  "prompt.menu.shellCommand": "Shell command",
  "prompt.attachment.remove": "Remove attachment",
  "prompt.action.send": "Send",
  "prompt.action.stop": "Stop",

  "prompt.toast.attachmentDuplicate.title": "This file has already been uploaded",
  "prompt.toast.uploading.percent": "{{percent}}%",
  "prompt.toast.uploading.cancel": "Cancel upload",
  "prompt.toast.uploading.cancelFile": "Cancel upload of {{filename}}",
  "prompt.toast.uploadFailed.title": "Upload failed",
  "prompt.toast.modelAgentRequired.title": "Select an agent and model",
  "prompt.toast.modelAgentRequired.description": "Choose an agent and model before sending a prompt.",
  "prompt.toast.worktreeCreateFailed.title": "Failed to create worktree",
  "prompt.toast.sessionCreateFailed.title": "Failed to create session",
  "prompt.toast.shellSendFailed.title": "Failed to send shell command",
  "prompt.toast.commandSendFailed.title": "Failed to send command",
  "prompt.toast.promptSendFailed.title": "Failed to send prompt",
  "prompt.toast.promptSendFailed.description": "Unable to retrieve session",

  "dialog.mcp.title": "MCPs",
  "dialog.mcp.description": "{{enabled}} of {{total}} enabled",
  "dialog.mcp.empty": "No MCPs configured",

  "dialog.lsp.empty": "LSPs auto-detected from file types",
  "dialog.plugins.empty": "Plugins configured in opencode.json",

  "mcp.status.connected": "connected",
  "mcp.status.failed": "failed",
  "mcp.status.needs_auth": "needs auth",
  "mcp.status.disabled": "disabled",
  "mcp.auth.clickToAuthenticate": "Click to authenticate",
  "mcp.auth.interactiveForm": "MCP server {{name}} requires an interactive authentication form",

  "dialog.fork.empty": "No messages to fork from",

  "dialog.directory.search.placeholder": "Search folders",
  "dialog.directory.empty": "No folders found",
  "dialog.directory.action.selectFile": "Select file",
  "dialog.directory.action.selectFolder": "Select folder",
  "dialog.directory.root": "Root",
  "dialog.directory.parent": "Parent",
  "dialog.directory.readError": "Unable to read this folder",

  "app.server.unreachable": "Could not reach {{server}}",
  "app.server.retrying": "Retrying automatically…",
  "app.server.otherServers": "Other servers",

  "dialog.server.title": "Servers",
  "dialog.server.description": "Switch which OpenTAG server this app connects to.",
  "dialog.server.search.placeholder": "Search servers",
  "dialog.server.empty": "No servers yet",
  "dialog.server.add.title": "Add server",
  "dialog.server.add.url": "Server address",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "Could not connect to server",
  "dialog.server.add.checking": "Checking…",
  "dialog.server.add.button": "Add server",
  "dialog.server.add.name": "Server name (optional)",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.password": "Password",
  "dialog.server.add.passwordPlaceholder": "password",

  "server.connect.title": "Connect to a server",
  "server.connect.description": "Enter your server address and password to get started.",
  "server.connect.button": "Connect",
  "server.connect.address.invalid": "Enter a valid HTTP or HTTPS server address.",
  "server.connect.failed": "Could not connect. Check the server address and password, then try again.",
  "server.connect.pair.description": "Or connect from the OpenTAG portal: open it and choose “Open assistant”.",
  "server.connect.scan": "Scan QR code",
  "server.connect.scan.description": "Point your camera at the QR code shown by opencode pair.",
  "server.connect.scan.invalid": "This is not an OpenTAG pairing code. Scan the code shown by opencode pair.",
  "server.connect.link.expired": "This pairing link expired or was already used. Run opencode pair to get a new one.",
  "server.connect.camera": "Pairing camera",
  "server.connect.camera.starting": "Opening camera…",
  "server.connect.mixedContent":
    "Could not connect to this HTTP server from an HTTPS page. Use an HTTPS server address instead.",
  "server.connect.localNetwork":
    "Your browser is asking for permission to reach apps on this device. Choose “Allow” on the prompt. If you denied it earlier, allow this site at chrome://settings/content/localNetworkAccess (or chrome://settings/content/loopbackNetwork) and try again. Also make sure the OpenTAG app is installed and running.",
  "server.connect.camera.insecure": "QR scanning requires opening this page over HTTPS or on localhost.",
  "server.connect.camera.unavailable":
    "No camera is available to this browser. Enter your connection details manually.",
  "server.connect.camera.error":
    "Could not open the camera. Allow camera access or enter your connection details manually.",
  "command.server.pair": "Pair device",
  "settings.pairing.title": "Pairing",
  "settings.pairing.connection": "Local Network",
  "pair.local.description": "View connection details and a QR code to connect a device on the same network.",
  "pair.local.open": "Show details",
  "pair.screenActive.title": "Keep screen active",
  "pair.screenActive.description": "Prevent this computer’s display from sleeping while OpenTAG is running.",
  "pair.screenActive.error": "Could not update the screen activity setting. Try again.",
  "pair.description": "Connect another device to this machine's OpenTAG server.",
  "pair.qr": "Pairing QR code",
  "pair.copy": "Copy details",
  "pair.copy.error": "Could not copy pairing details. Try again.",
  "pair.error": "Could not update pairing details. Try again.",
  "dialog.server.edit.title": "Edit server",
  "dialog.server.default.title": "Default server",
  "dialog.server.default.description":
    "Connect to this server on app launch instead of starting a local server. Requires restart.",
  "dialog.server.default.none": "No server selected",
  "dialog.server.default.set": "Set current server as default",
  "dialog.server.default.clear": "Clear",
  "dialog.server.action.remove": "Remove server",

  "dialog.server.menu.edit": "Edit",
  "dialog.server.menu.default": "Set as default",
  "dialog.server.menu.defaultRemove": "Remove default",
  "dialog.server.menu.delete": "Delete",
  "dialog.server.menu.remove": "Remove",
  "dialog.server.menu.hide": "Hide from project list",
  "dialog.server.menu.show": "Show in project list",
  "dialog.server.current": "Current Server",
  "dialog.server.status.default": "Default",
  "wsl.server.add": "Add WSL server",
  "wsl.server.addShort": "Add WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL server",
  "wsl.server.retryStart": "Retry start",
  "wsl.server.updating": "Updating…",
  "wsl.onboarding.step.distro": "Choose distro",
  "wsl.onboarding.step.opencode": "OpenTAG",
  "wsl.onboarding.checkingRuntime": "Checking WSL…",
  "wsl.onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "wsl.onboarding.ready": "WSL is ready.",
  "wsl.onboarding.required": "WSL is required to continue.",
  "wsl.onboarding.checkingDistros": "Checking distros…",
  "wsl.onboarding.installingDistro": "Installing {{distro}}…",
  "wsl.onboarding.checkingDistro": "Checking {{distro}}…",
  "wsl.onboarding.listingDistros": "Listing distros…",
  "wsl.onboarding.distroReady": "{{distro}} is ready.",
  "wsl.onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "wsl.onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "wsl.onboarding.finishingDistro": "Finishing setup for {{distro}}.",
  "wsl.onboarding.pickDistro": "Pick a distro or install one below.",
  "wsl.onboarding.checkingOpencode": "Checking OpenTAG…",
  "wsl.onboarding.checkingOpencodeIn": "Checking OpenTAG in {{distro}}…",
  "wsl.onboarding.updatingOpencode": "Updating OpenTAG…",
  "wsl.onboarding.updatingOpencodeIn": "Updating OpenTAG in {{distro}}…",
  "wsl.onboarding.updateOpencodeIn": "Update OpenTAG in {{distro}}.",
  "wsl.onboarding.updateOpencode": "Update OpenTAG",
  "wsl.onboarding.opencodeReadyIn": "OpenTAG is ready in {{distro}}.",
  "wsl.onboarding.opencodeReady": "OpenTAG is ready.",
  "wsl.onboarding.installOpencodeIn": "Install OpenTAG in {{distro}}.",
  "wsl.onboarding.installOpencode": "Install OpenTAG",
  "wsl.onboarding.chooseDistroFirst": "Choose a distro first.",
  "wsl.onboarding.loadFailed": "Failed to load WSL state.",
  "wsl.onboarding.loading": "Loading…",
  "wsl.onboarding.installedDistros": "Installed distros",
  "wsl.onboarding.checkAgain": "Check again",
  "wsl.onboarding.distroStatus.ready": "Ready",
  "wsl.onboarding.distroStatus.checking": "Checking…",
  "wsl.onboarding.distroStatus.opencodeMissing": "OpenTAG not installed",
  "wsl.onboarding.distroStatus.missingTools": "Missing bash, curl",
  "wsl.onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "wsl.onboarding.needAnotherDistro": "Need another distro?",
  "wsl.onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "wsl.onboarding.wslNotInstalled.title": "WSL not installed",
  "wsl.onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OpenTAG can add a WSL server",
  "wsl.onboarding.wslUnavailable.title": "WSL unavailable",
  "wsl.onboarding.wslUnavailable.description": "OpenTAG could not verify WSL on this machine.",
  "wsl.onboarding.installWsl": "Install WSL",
  "wsl.onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenTAG.",
  "wsl.onboarding.next": "Next",
  "wsl.onboarding.refresh": "Refresh",
  "wsl.onboarding.allDistrosAdded": "All installed distros are already added.",
  "wsl.onboarding.noDistros": "No distros detected yet.",
  "wsl.onboarding.install": "Install",
  "wsl.onboarding.installing": "Installing…",
  "wsl.onboarding.installDistro": "Install distro",
  "wsl.onboarding.searchDistros": "Search distros",
  "wsl.onboarding.wsl2Required": "WSL 2 is required.",
  "wsl.onboarding.toolsRequired": "This distro needs bash and curl.",
  "wsl.onboarding.openTerminal": "Open terminal",
  "wsl.onboarding.path": "Path: {{path}}",
  "wsl.onboarding.notFound": "not found",
  "wsl.onboarding.version": "Version: {{version}}",
  "wsl.onboarding.unknown": "unknown",
  "wsl.onboarding.desktopVersion": "desktop {{version}}",
  "wsl.onboarding.versionMismatch": "Installed version does not match the desktop app version.",
  "wsl.onboarding.adding": "Adding…",

  "server.row.incompatible":
    "This server is running OpenTAG {{version}}, which isn't compatible with this app. Upgrade it to OpenTAG V2 to continue.",

  "dialog.project.edit.title": "Edit project",
  "dialog.project.edit.name": "Name",
  "dialog.project.edit.icon": "Icon",
  "dialog.project.edit.icon.alt": "Project icon",
  "dialog.project.edit.icon.hint": "Click or drag an image",
  "dialog.project.edit.icon.recommended": "Recommended: 128x128px",
  "dialog.project.edit.color": "Color",
  "dialog.project.edit.color.select": "Select {{color}} color",
  "dialog.project.edit.worktree.startup": "Worktree startup script",
  "dialog.project.edit.worktree.startup.description":
    "Runs after creating a new worktree. Use $OPENCODE_WORKTREE_BASE for the base worktree and $OPENCODE_WORKTREE_PATH for the new worktree.",
  "dialog.project.edit.worktree.startup.placeholder": "e.g. bun install",

  "dialog.releaseNotes.action.getStarted": "Get started",
  "dialog.releaseNotes.action.next": "Next",
  "dialog.releaseNotes.action.hideFuture": "Don't show these in the future",
  "dialog.releaseNotes.media.alt": "Release preview",
  "dialog.usageExceeded.dontShowAgain": "Don't show again",

  "context.breakdown.title": "Context Breakdown",
  "context.breakdown.note": 'Approximate breakdown of input tokens. "Other" includes tool definitions and overhead.',
  "context.breakdown.system": "System",
  "context.breakdown.user": "User",
  "context.breakdown.assistant": "Assistant",
  "context.breakdown.tool": "Tool Calls",
  "context.breakdown.other": "Other",

  "context.systemPrompt.title": "System Prompt",
  "context.rawMessages.title": "Raw messages",
  "context.export.session": "Export session",

  "context.stats.session": "Session",
  "context.stats.messages": "Messages",
  "context.stats.provider": "Provider",
  "context.stats.model": "Model",
  "context.stats.limit": "Context Limit",
  "context.stats.totalTokens": "Total Tokens",
  "context.stats.usage": "Usage",
  "context.stats.inputTokens": "Input Tokens",
  "context.stats.outputTokens": "Output Tokens",
  "context.stats.reasoningTokens": "Reasoning Tokens",
  "context.stats.cacheTokens": "Cache Tokens (read/write)",
  "context.stats.userMessages": "User Messages",
  "context.stats.assistantMessages": "Assistant Messages",
  "context.stats.totalCost": "Total Cost",
  "context.stats.sessionCreated": "Session Created",
  "context.stats.lastActivity": "Last Activity",

  "context.usage.tokens": "Tokens",
  "context.usage.usage": "Context",
  "context.usage.cost": "Cost",
  "context.usage.clickToView": "Click to view context",
  "context.usage.view": "View context usage",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "Language",
  "toast.language.description": "Switched to {{language}}",

  "toast.theme.title": "Theme switched",
  "toast.scheme.title": "Color scheme",

  "toast.workspace.enabled.title": "Worktrees enabled",
  "toast.workspace.enabled.description": "Multiple worktrees are now shown in the sidebar",
  "toast.workspace.disabled.title": "Worktrees disabled",
  "toast.workspace.disabled.description": "Only the main worktree is shown in the sidebar",

  "toast.permissions.autoaccept.on.title": "Auto-accepting permissions",
  "toast.permissions.autoaccept.on.description": "Permission requests will be automatically approved",
  "toast.permissions.autoaccept.off.title": "Stopped auto-accepting permissions",
  "toast.permissions.autoaccept.off.description": "Permission requests will require approval",

  "toast.model.none.title": "No model selected",
  "toast.model.none.description": "Connect a provider to summarize this session",

  "toast.file.loadFailed.title": "Failed to load file",
  "file.error.notFound": "File not found: {{name}}",
  "toast.file.listFailed.title": "Failed to list files",
  "file.view.preview": "Preview",
  "file.view.source": "Source",
  "file.view.openInBrowser": "Open in browser",
  "file.view.binary": "Binary file · {{size}}",
  "file.view.table.rows.one": "{{count}} row",
  "file.view.table.rows.other": "{{count}} rows",
  "file.view.table.columns.one": "{{count}} column",
  "file.view.table.columns.other": "{{count}} columns",
  "file.view.table.truncated": "Showing the first {{shown}} of {{total}} rows.",
  "file.view.fontSample": "Sphinx of black quartz, judge my vow.",

  "toast.context.noLineSelection.title": "No line selection",
  "toast.context.noLineSelection.description": "Select a line range in a file tab first.",

  "toast.session.unshare.success.title": "Session unshared",
  "toast.session.unshare.success.description": "Session unshared successfully!",
  "toast.session.unshare.failed.title": "Failed to unshare session",
  "toast.session.unshare.failed.description": "An error occurred while unsharing the session",

  "toast.session.export.success.title": "Session exported",
  "toast.session.export.success.description": "Saved session to {{filename}}",
  "toast.session.export.failed.title": "Failed to export session",
  "toast.session.export.failed.description": "An error occurred while exporting the session",
  "toast.session.copyID.failed.title": "Failed to copy session ID",
  "toast.session.copyID.failed.description": "An error occurred while copying the session ID",
  "toast.project.copyID.failed.title": "Failed to copy project ID",
  "toast.project.copyID.failed.description": "An error occurred while copying the project ID",

  "toast.session.listFailed.title": "Failed to load sessions for {{project}}",
  "toast.project.reloadFailed.title": "Failed to reload {{project}}",
  "toast.migration.failed.title": "Data migration failed",
  "toast.migration.progress.clearingOldEvents": "Clearing old events",
  "toast.migration.progress.migratingSessions": "Migrating sessions",
  "toast.migration.progress.migratingSessions.current": "Migrating sessions {{current}}",
  "toast.migration.progress.migratingSessions.progress": "Migrating sessions {{current}}/{{total}}",
  "toast.migration.progress.working": "Migrating data",
  "toast.migration.progress.working.current": "Migrating data {{current}}",
  "toast.migration.progress.working.progress": "Migrating data {{current}}/{{total}}",

  "toast.update.title": "Update available",
  "toast.update.description": "A new version of OpenTAG ({{version}}) is now available to install.",
  "toast.update.action.installRestart": "Install and restart",
  "toast.update.action.notYet": "Not yet",

  "error.page.title": "Something went wrong",
  "error.page.title.status": "Server request failed",
  "error.page.description": "An error occurred while loading the application.",
  "error.page.description.status": "The server returned an HTTP {{status}} response.",
  "error.page.description.localServerStartup": "An error occurred while starting the local server.",
  "error.page.details.label": "Error Details",
  "error.page.action.restart": "Restart",
  "error.page.action.reload": "Reload",
  "error.page.action.report": "Report Error",
  "error.page.action.reported": "Error Reported",
  "error.page.action.exportLogs": "Export Logs",
  "error.page.action.checking": "Checking…",
  "error.page.action.checkUpdates": "Check for updates",
  "error.page.action.updateTo": "Update to {{version}}",
  "error.page.circular": "[Circular]",
  "error.page.report.prefix": "If the problem persists, return to the IT support portal:",
  "error.page.report.link": "opentag.nesiler.com",
  "error.page.report.discord": "on Discord",
  "error.page.version": "Version: {{version}}",

  "error.dev.rootNotFound":
    "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?",

  "error.serverSync.connectFailed": "Could not connect to server. Is there a server running at `{{url}}`?",
  "error.serverSDK.noServerAvailable": "No server available",
  "error.serverSDK.serverNotAvailable": "Server not available",
  "error.childStore.persistedCacheCreateFailed": "Failed to create persisted cache",
  "error.childStore.persistedProjectMetadataCreateFailed": "Failed to create persisted project metadata",
  "error.childStore.persistedProjectIconCreateFailed": "Failed to create persisted project icon",
  "error.childStore.storeCreateFailed": "Failed to create store",
  "directory.error.invalidUrl": "Invalid directory in URL.",

  "error.chain.unknown": "Unknown error",
  "error.server.invalidConfiguration": "Invalid configuration",
  "error.chain.causedBy": "Caused by:",
  "error.chain.apiError": "API error",
  "error.chain.status": "Status: {{status}}",
  "error.chain.retryable": "Retryable: {{retryable}}",
  "error.chain.responseBody": "Response body:\n{{body}}",
  "error.chain.didYouMean": "Did you mean: {{suggestions}}",
  "error.chain.modelNotFound": "Model not found: {{provider}}/{{model}}",
  "error.chain.checkConfig": "Check your config (opencode.json) provider/model names",
  "error.chain.mcpFailed": 'MCP server "{{name}}" failed. Note, OpenTAG does not support MCP authentication yet.',
  "error.chain.providerAuthFailed": "Provider authentication failed ({{provider}}): {{message}}",
  "error.chain.providerInitFailed":
    'Failed to initialize provider "{{provider}}". Check credentials and configuration.',
  "error.chain.configJsonInvalid": "Config file at {{path}} is not valid JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "Config file at {{path}} is not valid JSON(C): {{message}}",
  "error.chain.configDirectoryTypo":
    'Directory "{{dir}}" in {{path}} is not valid. Rename the directory to "{{suggestion}}" or remove it. This is a common typo.',
  "error.chain.configFrontmatterError": "Failed to parse frontmatter in {{path}}:\n{{message}}",
  "error.chain.configInvalid": "Config file at {{path}} is invalid",
  "error.chain.configInvalidWithMessage": "Config file at {{path}} is invalid: {{message}}",

  "notification.permission.title": "Permission required",
  "notification.permission.description": "{{sessionTitle}} in {{projectName}} needs permission",
  "notification.question.title": "Question",
  "notification.question.description": "{{sessionTitle}} in {{projectName}} has a question",
  "notification.action.goToSession": "Go to session",

  "notification.session.responseReady.title": "Response ready",
  "notification.session.error.title": "Session error",
  "notification.session.error.fallbackDescription": "An error occurred",

  "home.recentProjects": "Recent projects",
  "home.empty.title": "No recent projects",
  "home.empty.description": "Get started by opening a local project",
  "home.title": "Home",
  "home.projects": "Projects",
  "home.projects.all": "All projects",
  "home.project.add": "Add project",
  "home.project.missing.title": "Project folder not found",
  "home.project.missing.description": "The folder for {{name}} no longer exists.",
  "home.recentlyClosed": "Recently closed",
  "home.server.collapse": "Collapse server projects",
  "home.server.expand": "Expand server projects",
  "home.sessions.search.placeholder": "Search sessions",
  "home.sessions.search.placeholder.scoped": "Search sessions in {{scope}}",
  "home.sessions.search.sessions": "Sessions",
  "home.sessions.search.noResults": "No sessions found for {{query}}",
  "home.sessions.empty": "Nothing here yet",
  "home.sessions.empty.description": "Create a session to get started",
  "home.sessions.group.today": "Today",
  "home.sessions.group.yesterday": "Yesterday",
  "home.sessions.group.older": "Older",
  "home.providerTip": "Connect to 75+ providers to use other models, including Claude, GPT, Gemini, etc",
  "home.workspaceTip": "Start next session in a new workspace to keep changes isolated",

  "session.tab.session": "Session",
  "session.tab.files": "Files",
  "session.files.openTabs": "Open files",
  "session.tab.usage": "Usage",
  "session.view.select": "Session view",
  "session.tab.review": "Review",
  "session.tab.browser": "Browser",
  "session.tab.add": "Add tab",
  "session.tab.context": "Context",
  "session.tab.btw": "/btw",
  "session.tab.unknown": "Unknown Session",
  "session.panel.reviewAndFiles": "Review and files",
  "session.error.notFound": "This session cannot be found",
  "session.error.notFound.description": "This tab points to a session that no longer exists on this server.",
  "session.error.notFound.closeTab": "Close Tab",
  "session.error.incompatible": "This server version isn't supported",
  "session.error.incompatible.description":
    "{{server}} is running OpenTAG {{version}}, which isn't compatible with this app. Upgrade the server to OpenTAG V2 to continue.",
  "session.background.moveTasks": "Move {{tasks}} to background",
  "session.background.moveRunning": "Move to background",
  "session.background.inBackground": "Running {{tasks}} in background",
  "session.background.moveInline": "Press {{keybind}} to move running work to the background",
  "session.background.running": "Running work in background",
  "session.background.runningCount.one": "{{count}} item running in background",
  "session.background.runningCount.other": "{{count}} items running in background",
  "session.background.tasksRunning.one": "{{count}} background task running",
  "session.background.tasksRunning.other": "{{count}} background tasks running",
  "session.background.combine": "{{first}} and {{second}}",
  "session.background.shell.one": "{{count}} shell",
  "session.background.shell.other": "{{count}} shells",
  "session.background.subagent.one": "{{count}} subagent",
  "session.background.subagent.other": "{{count}} subagents",
  "command.session.background": "Move to background",
  "session.queue.count.one": "{{count}} queued",
  "session.queue.count.other": "{{count}} queued",
  "session.queue.steer": "Steer",
  "session.queue.send": "Send",
  "session.queue.steerTooltip": "Send without interrupting",
  "session.queue.remove": "Remove",
  "session.queue.undo": "Undo",
  "session.queue.undoShell": "Leave shell mode before undoing a queued prompt",
  "session.queue.undoUnavailable": "Edit this prompt in the queue to preserve its file context",
  "session.queue.reorder": "Reorder queued prompt",
  "session.queue.attachments.one": "{{count}} attachment",
  "session.queue.attachments.other": "{{count}} attachments",
  "session.timeline.working": "Working",
  "session.timeline.notice.finished": "{{actor}} finished",
  "session.timeline.notice.failed": "{{actor}} failed",
  "session.timeline.notice.cancelled": "{{actor}} cancelled",
  "session.error.serverConnection": "Can't connect to this server",
  "session.review.filesChanged": "Files Changed {{count}}",
  "session.review.filesChangedCount.one": "Files Changed {{count}}",
  "session.review.filesChangedCount.other": "Files Changed {{count}}",
  "session.review.change.one": "Change",
  "session.review.change.other": "Changes",
  "session.review.loadingChanges": "Loading changes…",
  "session.review.wrapLines": "Wrap lines",
  "session.review.empty": "No changes in this session yet",
  "session.review.noVcs": "No Git Version Control System detected, changes not displayed",
  "session.review.noVcs.createGit.title": "Create a Git repository",
  "session.review.noVcs.createGit.description": "Track, review, and undo changes in this project",
  "session.review.noVcs.createGit.actionLoading": "Creating Git repository…",
  "session.review.noVcs.createGit.action": "Create Git repository",
  "session.review.noSnapshot": "Snapshot tracking is disabled in config, so session changes are unavailable",
  "session.review.noChanges": "No changes",
  "session.review.noUncommittedChanges": "No uncommitted changes yet",
  "session.review.noBranchChanges": "No branch changes yet",

  "session.files.selectToOpen": "Select a file to open",
  "session.files.all": "All files",
  "session.files.empty": "No files",
  "session.files.binaryContent": "Binary file (content cannot be displayed)",

  "session.messages.renderEarlier": "Render earlier messages",
  "session.messages.loadingEarlier": "Loading earlier messages…",
  "session.messages.loadEarlier": "Load earlier messages",
  "session.messages.loading": "Loading messages…",
  "session.messages.jumpToLatest": "Jump to latest",

  "session.context.addToContext": "Add {{selection}} to context",
  "session.todo.title": "Todos",
  "session.todo.collapse": "Collapse",
  "session.todo.expand": "Expand",
  "session.todo.progress": "{{done}} of {{total}} todos completed",
  "session.question.progress": "{{current}} of {{total}} questions",
  "session.websearch.title": "Third-party web search",
  "session.websearch.description": "Select the search provider agents use to search the web",
  "session.websearch.provider": "Search provider",
  "session.websearch.any": "Any",
  "session.websearch.disable": "Don’t use search",
  "session.websearch.enable": "Enable",
  "session.websearch.loadFailed": "Could not load search providers.",
  "session.websearch.empty": "No search providers available.",
  "session.websearch.failed": "Could not save your choice. Please try again.",
  "session.websearch.retry": "Retry",
  "session.question.minimize": "Minimize question",
  "session.question.restore": "Restore question",
  "session.question.pending.one": "{{count}} pending question",
  "session.question.pending.other": "{{count}} pending questions",

  "session.new.title": "Build anything",
  "session.new.project.new": "New project",
  "session.new.project.search": "Search projects",
  "session.new.project.add": "Add project",
  "session.new.worktree.main": "Main branch",
  "session.new.worktree.mainWithBranch": "Main branch ({{branch}})",
  "session.new.worktree.create": "Create new worktree",
  "session.new.worktree.creating": "Creating worktree",
  "session.new.worktree.draftPlaceholder": "Draft a follow-up while the worktree is being prepared…",
  "session.new.workspace.runIn": "Run session in",
  "session.new.workspace.triggerLocal": "Local",
  "session.new.workspace.local": "Local repository",
  "session.new.workspace.existing": "Worktree…",
  "session.new.workspace.existingLabel": "Worktree",
  "session.new.git.none": "No Git",
  "session.new.lastModified": "Last modified",

  "session.header.search.placeholder": "Search {{project}}",
  "session.header.searchFiles": "Search files",
  "session.search.placeholder": "Find...",
  "session.search.noResults": "No matches",
  "session.header.openIn": "Open in",
  "session.header.open.action": "Open {{app}}",
  "session.header.open.ariaLabel": "Open in {{app}}",
  "session.header.open.menu": "Open options",
  "session.header.open.copyPath": "Copy path",
  "session.header.open.finder": "Finder",
  "session.header.open.fileExplorer": "File Explorer",
  "session.header.open.fileManager": "File Manager",
  "session.header.reveal.finder": "Reveal in Finder",
  "session.header.reveal.fileExplorer": "Reveal in File Explorer",
  "session.header.reveal.containingFolder": "Open containing folder",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "Terminal",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",

  "status.popover.trigger": "Status",
  "status.popover.ariaLabel": "Server configurations",
  "status.popover.tab.servers": "Servers",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "Plugins",
  "status.popover.action.manageServers": "Manage servers",

  "common.copied": "Copied",

  "lsp.tooltip.none": "No LSP servers",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "Loading prompt…",
  "terminal.loading": "Loading terminal…",
  "terminal.title": "Terminal",
  "terminal.title.numbered": "Terminal {{number}}",
  "terminal.close": "Close terminal",
  "terminal.connectionLost.title": "Connection Lost",
  "terminal.connectionLost.abnormalClose": "WebSocket closed abnormally: {{code}}",
  "terminal.connectionLost.description":
    "The terminal connection was interrupted. This can happen when the server restarts.",
  "terminal.connectTicket.csrfError":
    "PTY connect ticket rejected by origin or CSRF checks. Check the server CORS config.",
  "terminal.connectTicket.statusError": "PTY connect ticket failed with {{status}}",

  "session.browser.address": "Browser address",
  "session.browser.replaced": "Browser control moved to another desktop window.",
  "session.browser.unsupported": "This desktop app does not support the browser pane.",
  "session.browser.suspended": "Browser suspended. Interact with this session to reconnect.",
  "session.browser.address.placeholder": "Enter URL",
  "session.browser.empty.title": "Enter URL",
  "session.browser.empty.description": 'Or prompt "Open in the app browser"',
  "session.browser.failed.title": "URL can't be reached",
  "session.browser.failed.description": "Check the URL and your connection, then try again.",

  "titlebar.update": "Update",
  "titlebar.tabs": "Tabs",
  "titlebar.channel.local": "Local",
  "titlebar.channel.dev": "Dev",
  "titlebar.channel.beta": "Beta",
  "titlebar.toggleDebugTools": "Toggle debug tools",
  "titlebar.updateVersion": "Update {{version}}",

  "common.closeTab": "Close tab",
  "common.dismiss": "Dismiss",
  "common.moreCountSuffix": " (+{{count}} more)",
  "common.requestFailed": "Request failed",
  "session.btw.questionRequired": "Add a question after /btw",
  "session.btw.error": "Couldn’t answer that question",
  "session.btw.retry": "Retry",
  "session.btw.copy": "Copy answer",
  "common.moreOptions": "More options",
  "common.learnMore": "Learn more",
  "common.rename": "Rename",
  "common.export": "Export",
  "common.reset": "Reset",
  "common.archive": "Archive",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.edit": "Edit",
  "common.loadMore": "Load more",
  "common.key.esc": "ESC",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "Space",
  "common.key.backspace": "Backspace",
  "common.key.enter": "Enter",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "unknown",

  "common.time.justNow": "Just now",
  "common.time.minutesAgo.short": "{{count}}m ago",
  "common.time.hoursAgo.short": "{{count}}h ago",
  "common.time.daysAgo.short": "{{count}}d ago",

  "sidebar.menu.toggle": "Toggle menu",
  "sidebar.nav.projectsAndSessions": "Projects and sessions",
  "sidebar.settings": "Settings",
  "sidebar.help": "Help",
  "sidebar.workspaces.enable": "Enable worktrees",
  "sidebar.workspaces.disable": "Disable worktrees",
  "sidebar.gettingStarted.title": "Getting started",
  "sidebar.gettingStarted.line1": "OpenTAG includes free models so you can start immediately.",
  "sidebar.gettingStarted.line2": "Connect any provider to use models, inc. Claude, GPT, Gemini etc.",
  "sidebar.project.recentSessions": "Recent sessions",
  "sidebar.project.viewAllSessions": "View all sessions",
  "sidebar.project.clearNotifications": "Clear notifications",
  "sidebar.empty.title": "No projects open",
  "sidebar.empty.description": "Open a project to get started",

  "debugBar.ariaLabel": "Development performance diagnostics",
  "debugBar.providerAriaLabel": "Provider performance diagnostics",
  "debugBar.na": "n/a",
  "debugBar.ttft.label": "TTFT",
  "debugBar.ttft.tip": "Time from provider request dispatch to the first model output.",
  "debugBar.ttfa.label": "TTFA",
  "debugBar.ttfa.tip": "Time from provider request dispatch to the first answer text.",
  "debugBar.tps.label": "TPS",
  "debugBar.tps.tip": "Output tokens per second after the first model output.",
  "debugBar.e2e.label": "E2E",
  "debugBar.e2e.tip": "Time from provider request dispatch until its response stream ended.",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "Rolling frames per second over the last 5 seconds.",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "Worst frame time over the last 5 seconds.",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "Frames over 32ms in the last 5 seconds.",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "Worst observed input delay in the last 5 seconds.",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "Cumulative layout shift for the current app lifetime.",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "debugBar.mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "Force focus styles on all interactive elements",
  "debugBar.focus.on": "ON",
  "debugBar.focus.off": "OFF",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "Force the full app layout direction without changing the selected language",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",

  "app.name.desktop": "OpenTAG Desktop",

  "settings.section.desktop": "Desktop",
  "settings.section.server": "Server",
  "settings.backToApp": "Back to app",
  "settings.backToSettings": "Back to settings",
  "settings.backToProjects": "Back to projects",
  "settings.search.placeholder": "Search",
  "settings.search.results": "Settings results",
  "settings.search.group.pages": "Pages",
  "settings.search.group.settings": "Settings",
  "settings.search.group.projects": "Projects",
  "settings.search.group.servers": "Servers",
  "settings.search.result": "{{title}}, {{scope}}, {{page}}",
  "settings.search.page": "{{title}}, {{scope}}",
  "settings.search.result.unscoped": "{{title}}, {{page}}",
  "settings.search.empty": "No results for {{query}}",
  "settings.search.empty.query": '"{{query}}"',
  "settings.search.refine": "Narrow your search to see more specific results.",
  "settings.tab.general": "General",
  "settings.tab.preferences": "Preferences",
  "settings.tab.shortcuts": "Shortcuts",
  "settings.tab.notifications": "Notifications",
  "settings.tab.projects": "Projects",
  "settings.tab.extensions": "Extensions",
  "settings.tab.experimental": "Experimental",
  "settings.experimental.description": "Try experimental features",
  "settings.tab.about": "About",
  "settings.about.version": "Version {{version}}",
  "settings.about.devVersion": "development",
  "settings.about.license": "Released under the MIT License",
  "settings.about.writtenBy": "Written by",
  "settings.about.illustratedBy": "Illustrated by",
  "settings.about.and": "and",
  "settings.about.writtenByNames": "Written by {{names}}",
  "settings.about.illustratedByNames": "Illustrated by {{names}}",
  "settings.about.otherContributor.one": "{{count}} other",
  "settings.about.otherContributor.other": "{{count}} others",
  "settings.about.firstPublished": "First published in Missouri, USA",
  "settings.about.firstIllustrated": "First illustrated in London, England",
  "settings.about.website": "www.opencode.ai",
  "settings.about.description": "OpenTAG, the open source coding agent",
  "settings.about.trademark": "OpenTAG is a registered trademark of Anomaly Innovations, Inc.",
  "settings.about.typeset": "Typeset in Inter and IBM Plex Mono",
  "settings.about.tagline": "AI can’t build great software, without you",
  "settings.about.copyright": "© Anomaly Innovations, Inc.",
  "settings.preferences.description": "Customize preferences and theme and default behavior",
  "settings.appearance.description": "Customize theme and fonts",
  "settings.appearance.section.experimental": "Experimental",
  "settings.appearance.row.tabs.title": "Tabs",
  "settings.appearance.row.tabs.description": "Choose how session tabs are arranged",
  "settings.appearance.row.tabs.horizontal": "Horizontal",
  "settings.appearance.row.tabs.vertical": "Vertical",
  "settings.notifications.description": "Choose when to receive notifications and hear sounds",
  "settings.shortcuts.description": "Customize shortcuts for common actions",
  "settings.servers.description": "Manage server connections",
  "settings.server.description": "Manage this server’s connection and preferences",
  "settings.server.section.connection": "Connection",
  "settings.server.preferences.websearch.title": "Third-party search",
  "settings.server.preferences.websearch.description": "Select the search provider agents use to search the web",
  "settings.projects.title": "Projects",
  "settings.projects.description": "Manage projects and their settings",
  "settings.projects.empty": "No projects found",
  "settings.projects.empty.title": "No projects yet",
  "settings.projects.empty.description": "Add a project to get started",
  "settings.projects.search.placeholder": "Search projects",
  "settings.projects.server.all": "All servers",
  "settings.mcps.description": "Manage Model Context Protocol (MCP) servers and tools",
  "settings.extensions.description": "Manage extensions available on this server",
  "settings.extensions.tab.mcps": "MCPs",
  "settings.extensions.tab.skills": "Skills",
  "settings.extensions.availableAll": "Available to all projects",
  "settings.extensions.manageConfig": "Manage in opencode.json",
  "settings.extensions.addSkills": "How to add skills",
  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL integration",
  "settings.desktop.wsl.description": "Run the OpenTAG server inside WSL on Windows.",
  "dialog.server.authenticate.title": "Authenticate",
  "project.settings.title": "Edit project",
  "project.settings.general.description": "Manage project name and appearance",
  "project.settings.name.title": "Project name",
  "project.settings.name.description": "The name shown for this project throughout OpenTAG",
  "project.settings.icon.description": "Recommended: 128×128px. Click or drag to upload an image.",
  "project.settings.color.description": "Used for the project icon when no custom image is set",
  "project.settings.worktree.startup.description": "Runs once after creating a new worktree",
  "project.settings.worktree.startup.hint.base": "Use $OPENCODE_WORKTREE_BASE for the base worktree.",
  "project.settings.worktree.startup.hint.new": "Use $OPENCODE_WORKTREE_PATH for the new worktree.",
  "project.settings.scripts": "Scripts",
  "project.settings.scripts.description": "Configure scripts for this project",
  "project.settings.extensions.description": "View extensions available to this project",
  "project.settings.extensions.tab.lsps": "LSPs",
  "project.settings.extensions.added": "Added to this project",
  "project.settings.extensions.shared": "Shared with all projects",
  "project.settings.extensions.empty.mcps.title": "No MCPs yet",
  "project.settings.extensions.empty.mcps.description": "MCPs available to OpenTAG will appear here",
  "project.settings.extensions.empty.plugins.title": "No plugins yet",
  "project.settings.extensions.empty.plugins.description": "Plugins available to OpenTAG will appear here",
  "project.settings.extensions.empty.skills.title": "No skills yet",
  "project.settings.extensions.empty.skills.description": "Skills available to OpenTAG will appear here",
  "project.settings.extensions.lsp.detected": "Detected language servers",
  "project.settings.extensions.lsp.description": "Auto-detected from file types",
  "project.settings.extensions.lsp.configured": "Configured language servers",
  "project.settings.extensions.lsp.status.enabled": "Enabled in config",
  "project.settings.extensions.lsp.status.disabled": "Disabled in config",
  "project.settings.extensions.lsp.empty.title": "No language servers configured",
  "project.settings.extensions.lsp.empty.description": "Language servers configured for this project will appear here",
  "project.settings.extensions.lsp.disabled.title": "Language servers disabled",
  "project.settings.extensions.lsp.disabled.description": "LSP is disabled in this project’s configuration",
  "project.settings.extensions.lsp.loadFailed": "Could not load language server configuration",
  "project.settings.extensions.lsp.retry": "Retry",
  "project.settings.extensions.setupRequired": "Setup required",

  "settings.general.section.appearance": "Appearance",
  "settings.general.section.general": "General",
  "settings.general.section.advanced": "Advanced",
  "settings.general.section.notifications": "Desktop notifications",
  "settings.general.section.updates": "Updates",
  "settings.general.section.sounds": "Sound effects",
  "settings.general.section.feed": "Feed",
  "settings.general.section.display": "Display",

  "settings.timeline.title": "Timeline",
  "settings.timeline.detail": "Timeline detail",
  "settings.timeline.description": "Choose how much detail appears in the session timeline.",
  "settings.timeline.summary": "{{preset}}:",
  "settings.timeline.preset.everything": "Everything",
  "settings.timeline.preset.detailed": "Detailed",
  "settings.timeline.preset.compact": "Compact",
  "settings.timeline.preset.quiet": "Quiet",
  "settings.timeline.preset.text-only": "Messages only",
  "settings.timeline.description.everything": "Show all activity separately. Expand shell output, edits, and thinking.",
  "settings.timeline.description.detailed":
    "Expand shell output and edits. Show subagents separately and group other activity.",
  "settings.timeline.description.compact": "Group all activity with details collapsed.",
  "settings.timeline.description.quiet": "Group edits and subagents. Hide other activity.",
  "settings.timeline.description.text-only": "Hide all activity.",
  "settings.timeline.description.custom": "Uses advanced settings.",
  "settings.timeline.custom": "Custom",
  "settings.timeline.advanced": "Advanced",
  "settings.timeline.advanced.description": "Set placement and details for each activity category.",
  "settings.timeline.group": "Group",
  "settings.timeline.collapse": "Collapse",
  "settings.timeline.visibility.show": "Show",
  "settings.timeline.visibility.hide": "Hide",
  "settings.timeline.visibility.label": "{{activity}} visibility",
  "settings.timeline.grouped.label": "{{activity}} grouped",
  "settings.timeline.collapsed.label": "{{activity}} collapsed",
  "settings.timeline.category.shell": "Shell",
  "settings.timeline.category.edit": "Edits",
  "settings.timeline.category.thinking": "Thinking",
  "settings.timeline.category.subagents": "Subagents",
  "settings.timeline.category.notices": "Notices",
  "settings.timeline.category.tools": "Other tools",

  "settings.general.row.language.title": "Language",
  "settings.general.row.language.description": "Change the display language for OpenTAG",
  "settings.general.row.shell.title": "Terminal shell",
  "settings.general.row.shell.description": "Shell used by the terminal and agent tools",
  "settings.general.row.shell.autoDefault": "Auto (Default)",
  "settings.general.row.shell.terminalOnly": "terminal only",
  "settings.general.row.terminalPlacement.title": "Terminal placement",
  "settings.general.row.terminalPlacement.description": "Choose where the terminal opens in sessions",
  "settings.general.row.terminalPlacement.side": "Side",
  "settings.general.row.terminalPlacement.bottom": "Bottom",
  "settings.general.row.appearance.title": "Appearance",
  "settings.general.row.appearance.description": "Customise how OpenTAG looks on your device",
  "settings.general.row.colorScheme.title": "Color scheme",
  "settings.general.row.colorScheme.description": "Choose whether OpenTAG follows the system, light, or dark theme",
  "settings.general.row.theme.title": "Theme",
  "settings.general.row.theme.description": "Customise how OpenTAG is themed.",
  "settings.general.row.font.title": "Code Font",
  "settings.general.row.font.description": "Customise the font used in code blocks",
  "settings.general.row.terminalFont.title": "Terminal Font",
  "settings.general.row.terminalFont.description": "Customise the font used in the terminal",
  "settings.general.row.uiFont.title": "UI Font",
  "settings.general.row.uiFont.description": "Customise the font used throughout the interface",
  "settings.general.row.showFileTree.title": "File tree",
  "settings.general.row.showFileTree.description": "Show the file tree panel in sessions",
  "settings.general.row.showNavigation.title": "Navigation controls",
  "settings.general.row.showNavigation.description": "Show the back and forward buttons in the desktop title bar",
  "settings.general.row.showSearch.title": "Command palette",
  "settings.general.row.showSearch.description": "Show the search and command palette button in the title bar",
  "settings.general.row.showTerminal.title": "Terminal",
  "settings.general.row.showTerminal.description": "Show the terminal button in the desktop title bar",
  "settings.general.row.showStatus.title": "Server status",
  "settings.general.row.showStatus.description": "Show the server status button in the title bar",
  "settings.general.row.mobileTitlebarBottom.title": "Bottom navigation",
  "settings.general.row.mobileTitlebarBottom.description": "Place the title bar at the bottom of the screen on mobile",
  "settings.general.row.mobileDiffWrap.description":
    "Wrap long lines in mobile diffs instead of scrolling horizontally",
  "settings.general.row.showCustomAgents.title": "Show agent",
  "settings.general.row.showCustomAgents.description":
    "Switch between agents in the composer. When hidden, defaults to Build agent.",
  "settings.general.row.followUpBehavior.title": "Follow-up behavior",
  "settings.general.row.followUpBehavior.description":
    "Choose whether to queue follow-ups or steer the current turn. Use {{keybind}} to switch.",
  "settings.general.row.followUpBehavior.queue": "Queue",
  "settings.general.row.followUpBehavior.steer": "Steer",
  "settings.general.row.reasoningSummaries.title": "Show reasoning summaries",
  "settings.general.row.reasoningSummaries.description": "Display model reasoning summaries in the timeline",
  "settings.general.row.reasoningMode.title": "Model reasoning",
  "settings.general.row.reasoningMode.description": "Choose how model reasoning is displayed in the timeline",
  "settings.general.row.reasoningMode.hidden": "Hidden",
  "settings.general.row.reasoningMode.compact": "Compact",
  "settings.general.row.reasoningMode.full": "Full",
  "settings.general.row.shellToolPartsExpanded.title": "Expand shell tool parts",
  "settings.general.row.shellToolPartsExpanded.description":
    "Show shell tool parts expanded by default in the timeline",
  "settings.general.row.editToolPartsExpanded.title": "Expand edit tool parts",
  "settings.general.row.editToolPartsExpanded.description":
    "Show edit, write, and patch tool parts expanded by default in the timeline",
  "settings.general.row.pinchZoom.title": "Pinch to zoom",
  "settings.general.row.pinchZoom.description": "Allow trackpad pinch and Ctrl-scroll gestures to zoom",

  "settings.general.row.wayland.title": "Use native Wayland",
  "settings.general.row.wayland.description": "Disable X11 fallback on Wayland. Requires restart.",
  "settings.general.row.wayland.tooltip":
    "On Linux with mixed refresh-rate monitors, native Wayland can be more stable.",

  "settings.general.row.releaseNotes.title": "Release notes",
  "settings.general.row.releaseNotes.description": "Show What's New popups after updates",

  "settings.updates.row.startup.title": "Check for updates on startup",
  "settings.updates.row.startup.description": "Automatically check for updates when OpenTAG launches",
  "settings.updates.row.check.title": "Check for updates",
  "settings.updates.row.check.description": "Manually check for updates and install if available",
  "settings.updates.action.checkNow": "Check now",
  "settings.updates.action.checking": "Checking…",
  "settings.updates.action.downloading": "Downloading…",
  "settings.updates.action.download": "Download OpenTAG",
  "settings.updates.migration.title": "Move from Beta to Stable",
  "settings.updates.migration.description":
    "For now, OpenTAG Beta is moving to OpenTAG Stable. Download version {{version}}, then install OpenTAG from the disk image to continue receiving updates.",
  "settings.updates.action.installing": "Installing…",
  "settings.updates.toast.latest.title": "You're up to date",
  "settings.updates.toast.latest.description": "You're running the latest version of OpenTAG.",
  "sound.option.none": "None",
  "sound.option.alert01": "Alert 01",
  "sound.option.alert02": "Alert 02",
  "sound.option.alert03": "Alert 03",
  "sound.option.alert04": "Alert 04",
  "sound.option.alert05": "Alert 05",
  "sound.option.alert06": "Alert 06",
  "sound.option.alert07": "Alert 07",
  "sound.option.alert08": "Alert 08",
  "sound.option.alert09": "Alert 09",
  "sound.option.alert10": "Alert 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "Agent",
  "settings.general.notifications.agent.description":
    "Show system notification when the agent is complete or needs attention",
  "settings.general.notifications.permissions.title": "Permissions",
  "settings.general.notifications.permissions.description": "Show system notification when a permission is required",
  "settings.general.notifications.errors.title": "Errors",
  "settings.general.notifications.errors.description": "Show system notification when an error occurs",

  "settings.general.sounds.agent.title": "Agent",
  "settings.general.sounds.agent.description": "Play sound when the agent is complete or needs attention",
  "settings.general.sounds.permissions.title": "Permissions",
  "settings.general.sounds.permissions.description": "Play sound when a permission is required",
  "settings.general.sounds.errors.title": "Errors",
  "settings.general.sounds.errors.description": "Play sound when an error occurs",

  "settings.shortcuts.title": "Keyboard shortcuts",
  "settings.shortcuts.reset.button": "Reset to defaults",
  "settings.shortcuts.reset.toast.title": "Shortcuts reset",
  "settings.shortcuts.reset.toast.description": "Keyboard shortcuts have been reset to defaults.",
  "settings.shortcuts.conflict.title": "Shortcut already in use",
  "settings.shortcuts.conflict.description": "{{keybind}} is already assigned to {{titles}}.",
  "settings.shortcuts.unassigned": "Unassigned",
  "settings.shortcuts.pressKeys": "Press keys",
  "settings.shortcuts.search.placeholder": "Search shortcuts",
  "settings.shortcuts.search.empty": "No shortcuts found",

  "settings.shortcuts.group.general": "General",
  "settings.shortcuts.group.session": "Session",
  "settings.shortcuts.group.navigation": "Navigation",
  "settings.shortcuts.group.modelAndAgent": "Model and agent",
  "settings.shortcuts.group.terminal": "Terminal",
  "settings.shortcuts.group.prompt": "Prompt",

  "settings.providers.title": "Providers",
  "settings.providers.description": "Connect and manage model providers",
  "settings.providers.section.connected": "Connected providers",
  "settings.providers.connected.empty": "No connected providers",
  "settings.providers.connected.environmentDescription": "Connected from your environment variables",
  "settings.providers.account.manage": "Manage {{provider}} accounts",
  "settings.providers.account.group": "Accounts",
  "settings.providers.account.add": "Add account",
  "settings.providers.account.remove": "Remove account…",
  "settings.providers.account.active": "Active",
  "settings.providers.account.switched.title": "{{provider}} account switched",
  "settings.providers.account.switched.description": "Now using {{account}}.",
  "settings.providers.account.removed.title": "{{account}} removed",
  "settings.providers.account.removed.description": "{{provider}} will no longer use this account.",
  "settings.providers.console.available.one": "{{count}} provider available",
  "settings.providers.console.available.other": "{{count}} providers available",
  "settings.providers.section.popular": "Popular providers",
  "settings.providers.custom.description": "Add an OpenAI-compatible provider by base URL.",
  "settings.providers.tag.environment": "Environment",
  "settings.providers.tag.config": "Config",
  "settings.providers.tag.custom": "Custom",
  "settings.providers.tag.account": "Account",
  "settings.providers.tag.other": "Other",
  "settings.models.title": "Models",
  "settings.models.description": "Choose which models appear in model picker",
  "settings.models.enableAll": "Enable all models",
  "settings.models.disableAll": "Disable all models",
  "settings.agents.title": "Agents",
  "settings.agents.description": "Agent settings will be configurable here.",
  "settings.commands.title": "Commands",
  "settings.commands.description": "Command settings will be configurable here.",
  "settings.mcp.title": "MCP",
  "settings.mcp.description": "MCP settings will be configurable here.",

  "settings.permissions.title": "Permissions",
  "settings.permissions.description": "Control what tools the server can use by default.",
  "settings.permissions.section.tools": "Tools",
  "settings.permissions.toast.updateFailed.title": "Failed to update permissions",

  "settings.permissions.action.allow": "Allow",
  "settings.permissions.action.ask": "Ask",
  "settings.permissions.action.deny": "Deny",

  "settings.permissions.tool.read.title": "Read",
  "settings.permissions.tool.read.description": "Reading a file (matches the file path)",
  "settings.permissions.tool.edit.title": "Edit",
  "settings.permissions.tool.edit.description": "Modify files, including edits, writes, and patches",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "Match files using glob patterns",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "Search file contents using regular expressions",
  "settings.permissions.tool.list.title": "List",
  "settings.permissions.tool.list.description": "List files within a directory",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "Run shell commands",
  "settings.permissions.tool.task.title": "Task",
  "settings.permissions.tool.task.description": "Launch sub-agents",
  "settings.permissions.tool.skill.title": "Skill",
  "settings.permissions.tool.skill.description": "Load a skill by name",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "Run language server queries",
  "settings.permissions.tool.todowrite.title": "Todo Write",
  "settings.permissions.tool.todowrite.description": "Update the todo list",
  "settings.permissions.tool.webfetch.title": "Web Fetch",
  "settings.permissions.tool.webfetch.description": "Fetch content from a URL",
  "settings.permissions.tool.websearch.title": "Web Search",
  "settings.permissions.tool.websearch.description": "Search the web",
  "settings.permissions.tool.external_directory.title": "External Directory",
  "settings.permissions.tool.external_directory.description": "Access files outside the project directory",
  "settings.permissions.tool.doom_loop.title": "Doom Loop",
  "settings.permissions.tool.doom_loop.description": "Detect repeated tool calls with identical input",

  "session.delete.failed.title": "Failed to delete session",
  "session.delete.title": "Delete session",
  "session.delete.confirm": 'Delete session "{{name}}"?',
  "session.delete.button": "Delete session",

  "workspace.new": "New worktree",
  "common.viewAll": "View all",
  "session.new.workspace.local.tooltip": "Uses project’s current checkout",
  "session.new.workspace.new.tooltip": "Creates isolated copy from current checkout",
  "session.new.workspace.fromBranch": "from {{branch}}",
  "session.new.workspace.createFrom": "Create from branch",
  "session.new.workspace.branch.search.placeholder": "Search branches",
  "session.new.workspace.trigger.tooltip": "Select where to run session",
  "session.new.workspace.search.placeholder": "Search worktrees",
  "session.new.workspace.search.empty": "No matching worktrees",
  "settings.tab.workspaces": "Worktrees",
  "settings.workspaces.description": "Review worktrees and manage disk usage",
  "settings.workspaces.filter.all": "All projects",
  "settings.workspaces.empty": "No worktrees yet",
  "settings.workspaces.empty.description": "Worktrees created in OpenTAG will appear here",
  "settings.workspaces.count.one": "{{count}} worktree",
  "settings.workspaces.count.other": "{{count}} worktrees",
  "settings.workspaces.sessions.one": "{{count}} session in {{project}}",
  "settings.workspaces.sessions.other": "{{count}} sessions in {{project}}",
  "settings.workspaces.sessions.filtered.one": "{{count}} session",
  "settings.workspaces.sessions.filtered.other": "{{count}} sessions",
  "settings.workspaces.lastActiveSession": "Last active session",
  "settings.workspaces.deleteAll": "Delete all worktrees",
  "settings.workspaces.deleteAll.confirm.one": "This will permanently delete {{count}} selected worktree.",
  "settings.workspaces.deleteAll.confirm.other": "This will permanently delete {{count}} selected worktrees.",
  "settings.workspaces.deleteWithoutSessions": "Delete worktrees without sessions",
  "settings.workspaces.deleteWithoutSessions.confirm.one":
    "This will permanently delete {{count}} worktree without linked sessions.",
  "settings.workspaces.deleteWithoutSessions.confirm.other":
    "This will permanently delete {{count}} worktrees without linked sessions.",
  "settings.workspaces.deleteWithoutSessions.warning":
    "Worktrees with unmerged changes or active locations will be kept.",
  "settings.workspaces.delete.button": "Delete worktrees",
  "settings.workspaces.delete.warning": "This permanently deletes the worktree and its branch.",
  "settings.workspaces.deleteAll.warning":
    "Worktrees with unmerged changes, linked sessions, or active locations will be kept.",
  "settings.workspaces.delete.blocked.active": "The active worktree cannot be deleted.",
  "settings.workspaces.delete.blocked.linked":
    "Linked sessions will remain, but their working directory will no longer exist.",
  "settings.workspaces.default.title": "Default environment",
  "settings.workspaces.default.description": "Choose where new sessions start",
  "settings.workspaces.default.lastUsed": "Last used per project",
  "settings.workspaces.default.local": "Local directory",
  "settings.workspaces.default.new": "New worktree",
  "workspace.move.title": "Move to worktree",
  "workspace.move.menu.title": "Move session to",
  "workspace.move.failed": "Failed to move session",
  "workspace.lifecycle.creating": "Creating worktree",
  "workspace.lifecycle.created": "Worktree created",
  "workspace.lifecycle.deleting": "Deleting…",
  "workspace.lifecycle.starting": "Starting session",
  "workspace.onboarding.title": "Isolate sessions with worktrees",
  "workspace.onboarding.description": "Each gets its own checkout",
  "workspace.lifecycle.moving": "Moving to worktree",
  "workspace.lifecycle.set": "Worktree set",
  "session.summary.title": "Session details",
  "session.summary.tooltip": "Summary",
  "session.summary.noBranch": "No branch",
  "session.summary.basedOn": "Based on {{branch}}",
  "session.summary.server": "Extensions",
  "session.summary.chooseProject": "Choose a project",
  "session.summary.mcp.onCreation": "Applies when the worktree is created",
  "session.summary.mcp.prepareFailed": "Could not prepare MCP servers",
  "session.summary.mcp.unavailable": "MCP server {{name}} is not available in this worktree.",
  "session.summary.mcp.signInBeforeSend": "Sign in to {{name}} before sending the prompt.",
  "session.summary.mcp.notReady": "MCP server {{name}} is not ready. Resolve its connection before sending the prompt.",
  "session.summary.mcp": "MCP",
  "session.summary.mcp.title": "Configured MCP servers",
  "session.summary.plugins": "Plugins",
  "session.summary.plugins.configured": "Configured plugins",
  "session.summary.skills": "Skills",
  "session.summary.skills.configured": "Configured skills",
  "session.summary.lsp": "LSP",
  "session.summary.failed": "Failed",
  "session.summary.retry": "Retry",
  "session.summary.connecting": "Connecting…",
  "session.summary.needsAuth": "Sign in required",
  "session.summary.configure": "Configuration file",
  "session.summary.copyConfigPath": "Copy configuration file path",
  "session.summary.configFileMissing": "No configuration file found",
  "session.summary.mcp.empty": "No MCP servers configured",
  "session.summary.mcp.add": "Add servers in opencode.json",
  "session.summary.plugins.manage": "Manage plugins in opencode.json",
  "session.summary.plugins.empty": "No plugins configured",
  "session.summary.plugins.add": "Add plugins in opencode.json",
  "session.summary.skills.manage": "Manage skills in opencode.json",
  "session.summary.skills.empty": "No skills configured",
  "session.summary.skills.add": "Add skills in opencode.json",
  "session.summary.lsp.configured": "Configured LSPs",
  "session.summary.lsp.empty": "No LSP servers configured",
  "session.summary.lsp.manage": "Manage LSP in opencode.json",
  "workspace.type.local": "local",
  "workspace.type.sandbox": "sandbox",
  "workspace.create.failed.title": "Failed to create worktree",
  "workspace.delete.failed.title": "Failed to delete worktree",
  "workspace.resetting.title": "Resetting worktree",
  "workspace.resetting.description": "This may take a minute.",
  "workspace.reset.failed.title": "Failed to reset worktree",
  "workspace.reset.success.title": "Worktree reset",
  "workspace.reset.success.description": "Worktree now matches the default branch.",
  "workspace.error.stillPreparing": "Worktree is still preparing",
  "workspace.status.checking": "Checking for unmerged changes…",
  "workspace.status.error": "Unable to verify git status.",
  "workspace.status.clean": "No unmerged changes detected.",
  "workspace.status.dirty": "Unmerged changes will be lost.",
  "workspace.delete.title": "Delete worktree",
  "workspace.delete.confirm": "Delete “{{name}}”?",
  "workspace.delete.location": "Location",
  "workspace.delete.button": "Delete worktree",
  "workspace.reset.title": "Reset worktree",
  "workspace.reset.confirm": 'Reset worktree "{{name}}"?',
  "workspace.reset.button": "Reset worktree",
  "workspace.reset.archived.none": "No active sessions will be archived.",
  "workspace.reset.archived.one": "1 session will be archived.",
  "workspace.reset.archived.many": "{{count}} sessions will be archived.",
  "workspace.reset.note": "This will reset the worktree to match the default branch.",
}

export default dict
